export const REDUCER_NAME = 'partner'



// WEBPACK FOOTER //
// ./src/modules/partner/state/const.js